import clsx from 'clsx';

import { partnerSubLabel, partnerSubTone, type PartnerRow } from '@/lib/partners';

const TONES = {
  green: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  amber: 'bg-amber-50 text-amber-700 border-amber-200',
  red: 'bg-rose-50 text-rose-700 border-rose-200',
  slate: 'bg-ink/5 text-ink/60 border-line',
} as const;

/** Плашка подписки поставщика или оптовика — по фактическому доступу, как StatusPill у заведений. */
export function PartnerPill({
  row,
}: {
  row: Pick<PartnerRow, 'subscriptionStatus' | 'accessState' | 'daysLeft'>;
}) {
  return (
    <span
      className={clsx(
        'inline-flex items-center whitespace-nowrap rounded-md border px-2 py-0.5 text-[11px] font-medium',
        TONES[partnerSubTone(row)],
      )}
    >
      {partnerSubLabel(row)}
    </span>
  );
}
